/* RAVIN Sidekick Native / data-only v1. Theme presentation; Sidekick remains source of truth. */
(()=>{
  if(window.__rvSidekickNativeV1)return;window.__rvSidekickNativeV1=true;
  const dictionary={
    en:{stores:'CHECK IN-STORE AVAILABILITY',storeSub:'Availability for your selected size and color',loadStores:'Checking availability in RAVIN stores…',noStores:'This item is not currently available in our stores.',search:'Search stores or cities',available:'Available in store',limited:'Limited stock',maps:'View on Google Maps',more:'SHOW ALL STORES',less:'SHOW FEWER',noMatches:'No stores match your search.',update:'Availability may change.',installments:'INSTALLMENT PLANS',loadPlans:'Finding available installment plans…',noPlans:'No eligible installment plans for this product price.',perMonth:'per month',payToday:'Payable today',total:'Total payable',terms:'Terms & conditions',months:'months',promotions:'SPECIAL OFFER',basedOn:'Calculated from displayed product price',disclaimer:'Plans and final eligibility are determined by the installment provider. Checkout discounts may change the payable amount.',failed:'Unable to load live information. Please try again.',retry:'TRY AGAIN',estimated:'Estimates from the installment provider.',plans:'available plans'},
    ar:{stores:'التوفر في الفروع',storeSub:'التوفر للمقاس واللون المختارين',loadStores:'جاري فحص التوفر في فروع ريفين…',noStores:'المنتج غير متوفر في الفروع حالياً.',search:'ابحث عن فرع أو مدينة',available:'متوفر في الفرع',limited:'كمية محدودة',maps:'افتح على خرائط جوجل',more:'عرض كل الفروع',less:'عرض عدد أقل',noMatches:'مفيش فروع مطابقة للبحث.',update:'التوفر في الفروع ممكن يتغير.',installments:'خطط التقسيط',loadPlans:'جاري تحميل خطط التقسيط…',noPlans:'مفيش خطط تقسيط متاحة للسعر ده حالياً.',perMonth:'شهرياً',payToday:'المطلوب اليوم',total:'إجمالي المطلوب',terms:'الشروط والتفاصيل',months:'شهور',promotions:'عرض خاص',basedOn:'التقسيط محسوب على سعر المنتج المعروض',disclaimer:'الخطط والموافقة النهائية حسب جهة التقسيط. خصومات الدفع النهائية ممكن تغير قيمة الأوردر.',failed:'تعذر تحميل البيانات الحية. حاول تاني.',retry:'حاول تاني',estimated:'الأرقام تقديرية حسب جهة التقسيط.',plans:'خطة متاحة'}
  };
  const h=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeUrl=value=>{try{const u=new URL(String(value));return u.protocol==='https:'?u.href:''}catch{return''}};
  const logoUrl=value=>{const v=String(value||'');return /^data:image\/(?:png|jpeg|webp);base64,[a-z0-9+/=]+$/i.test(v)&&v.length<250000?v:safeUrl(v)};
  const price=v=>Number.isFinite(Number(v))?new Intl.NumberFormat('en-EG',{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(v))+' EGP':'—';
  const locale=s=>s==='ar'?'ar':'en';
  const line=(label,value)=>'<div class="rv-sk__fact"><span>'+h(label)+'</span><strong>'+h(value)+'</strong></div>';
  function init(el){
    if(el.dataset.rvSkReady==='1')return;
    el.dataset.rvSkReady='1';
    const pdp=el.closest('[data-rv-pdp-garment-file]');
    if(!pdp)return;
    const service=el.dataset.rvSidekickNative;
    if(service!=='stores'&&service!=='installments')return;
    const lang=locale(el.dataset.lang||document.documentElement.lang?.slice(0,2));
    const t=k=>dictionary[lang][k]||k;
    const apiHost=String(el.dataset.api||'').replace(/\/+$/,'');
    const productId=String(el.dataset.productId||'');
    const storefrontCurrency=String(el.dataset.currency||'EGP').toUpperCase();
    const termSelection=new Map();
    let controller=null,seq=0,current=null,cache=null,inFlightKey=null;
    let search='',limit=6;
    const details=el.closest('details');
    function selectedVariant(){return pdp.currentVariant||null}
    function storeSizePicker(){
      if(service!=='stores')return '';
      const sizeGroup=Array.from(pdp.querySelectorAll('[data-variant-container]'))
        .find(group=>(group.dataset.variantContainer||'').trim().toLowerCase()==='size');
      if(!sizeGroup)return '';
      const inputs=Array.from(sizeGroup.querySelectorAll('[data-option-input]'))
        .filter(input=>input.value && !/^DEF$/i.test(input.value.trim()));
      if(!inputs.length)return '';
      const selected=new Map(Array.from(pdp.querySelectorAll('[data-product-form] [data-option-input]:checked'))
        .map(input=>[Number(input.dataset.optionPosition),input.value]));
      const sizePosition=Number(inputs[0].dataset.optionPosition);
      const all=Array.isArray(pdp.productData)?pdp.productData:[];
      const buttons=inputs.map(input=>{
        const size=input.value;
        const matches=all.filter(v=>{
          if(!v||!Array.isArray(v.options)||
            v.options.some(o=>/^DEF$/i.test(String(o).trim()))||
            v.options[sizePosition-1]!==size)return false;
          for(const [pos,val] of selected)if(pos!==sizePosition&&v.options[pos-1]!==val)return false;
          return true;
        });
        const exists=matches.length>0;
        const online=matches.some(v=>v.available);
        const active=selected.get(sizePosition)===size;
        const desc=!exists?(lang==='ar'?'غير متاح مع اللون المختار':'Not offered with selected color'):
          !online?(lang==='ar'?'غير متوفر أونلاين؛ افحص الفروع':'Sold out online; check stores'):'';
        return '<button type="button" class="rv-sk__size'+(active?' is-selected':'')+
          (!online&&exists?' is-online-soldout':'')+
          '" data-rv-sk-size="'+h(size)+'" aria-pressed="'+active+'"'+(!exists?' disabled':'')+
          ' aria-label="'+h(size+(desc?' — '+desc:''))+'">'+h(size)+'</button>';
      }).join('');
      const current=selectedVariant();
      const soldOut=current&&!current.available?
        '<p class="rv-sk__online-note">'+h(lang==='ar'
          ?'المقاس ده مش متوفر أونلاين؛ بنراجع توفره في الفروع.'
          :'Not available online. Checking physical-store stock for this size.')+'</p>':'';
      return '<div class="rv-sk__picker" role="group" aria-label="'+
        h(lang==='ar'?'المقاس المطلوب في الفروع':'Size to check in stores')+'">'+
        '<div class="rv-sk__picker-title"><strong>'+h(lang==='ar'?'اختار المقاس':'CHECK A SIZE')+
        '</strong><span>'+h(lang==='ar'?'اختار المقاس حتى لو مش متوفر أونلاين':'Online-sold-out sizes can still be checked')+
        '</span></div><div class="rv-sk__size-row">'+buttons+'</div>'+soldOut+'</div>';
    }
    function bindStoreSizePicker(){
      if(service!=='stores')return;
      const sizeGroup=Array.from(pdp.querySelectorAll('[data-variant-container]'))
        .find(group=>(group.dataset.variantContainer||'').trim().toLowerCase()==='size');
      if(!sizeGroup)return;
      el.querySelectorAll('[data-rv-sk-size]').forEach(button=>button.addEventListener('click',()=>{
        if(button.disabled)return;
        const input=Array.from(sizeGroup.querySelectorAll('[data-option-input]'))
          .find(x=>x.value===button.dataset.rvSkSize);
        if(!input||input.checked)return;
        input.checked=true;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }));
    }

    function currentPrice(variant){
      if(typeof pdp.calculateEffectivePriceMinorUnits!=='function')return null;
      const n=Number(pdp.calculateEffectivePriceMinorUnits(variant));
      return Number.isSafeInteger(n)&&n>0?n:null;
    }
    function loading(){
      el.innerHTML=(service==='stores'?storeSizePicker():'')+
        '<div class="rv-sk__loading" role="status"><span class="rv-sk__pulse" aria-hidden="true"></span><span><strong>RAVIN / '+
        (service==='stores'?'SHOPIFY STORES':'SHOPIFY PAYMENTS')+'</strong><br>'+
        h(t(service==='stores'?'loadStores':'loadPlans'))+'</span></div>';
      bindStoreSizePicker();
    }
    function error(code='API_UNAVAILABLE'){
      const safeCode=String(code).replace(/[^A-Z0-9_]/g,'').slice(0,32)||'API_UNAVAILABLE';
      el.dataset.rvSkError=safeCode;
      const detail=lang==='ar'?'رمز مشكلة الاتصال: ':'Connection diagnostic: ';
      el.innerHTML=(service==='stores'?storeSizePicker():'')+
        '<div class="rv-sk__error" role="alert"><p>'+h(t('failed'))+'</p><small>'+h(detail+safeCode)+'</small><button type="button" data-rv-sk-retry>'+h(t('retry'))+' ↗</button></div>';
      bindStoreSizePicker();
      el.querySelector('[data-rv-sk-retry]')?.addEventListener('click',()=>refresh(true));
    }
    function listStores(){
      if(!cache)return;
      const value=cache,raw=Array.isArray(value.stores)?value.stores:[];
      if(value.featureEnabled===false){el.innerHTML=storeSizePicker()+'<p class="rv-sk__empty">'+h(t('noStores'))+'</p>';bindStoreSizePicker();return}
      const found=raw.filter(x=>[x.storeNameEn,x.storeNameAr,x.addressEn,x.addressAr,x.city].join(' ').toLocaleLowerCase().includes(search.toLocaleLowerCase()));
      const visible=found.slice(0,limit);
      const state=raw.length?'':'<p class="rv-sk__empty">'+h(value.settings?.[lang==='ar'?'noAvailMsgAr':'noAvailMsgEn']||t('noStores'))+'</p>';
      let markup='<div class="rv-sk__section"><div class="rv-sk__heading"><span class="rv-sk__eyebrow">RAVIN / STORES</span><strong>'+h(t('stores'))+'</strong><small>'+h(t('storeSub'))+'</small></div>'+storeSizePicker();
      if(raw.length>1)markup+='<label class="rv-sk__search"><span class="rv-sk__sr">'+h(t('search'))+'</span><input type="search" inputmode="search" data-rv-sk-search placeholder="'+h(t('search'))+'" value="'+h(search)+'" autocomplete="off"></label>';
      markup+=state;
      if(raw.length&&!found.length)markup+='<p class="rv-sk__empty">'+h(t('noMatches'))+'</p>';
      if(visible.length){
        markup+='<div class="rv-sk__stores">';
        for(const item of visible){
          const limited=item.isLimitedStock===true||String(item.stockStatusCode||'').toLowerCase()==='low_stock';
          const name=item[lang==='ar'?'storeNameAr':'storeNameEn']||item.storeNameEn||'—';
          const address=item[lang==='ar'?'addressAr':'addressEn']||item.addressEn||'';
          const lbl=item[lang==='ar'?'statusLabelAr':'statusLabelEn']||t(limited?'limited':'available');
          const url=safeUrl(item.googleMapsUrl);
          markup+='<article class="rv-sk__store"><div class="rv-sk__store-top"><h4>'+h(name)+'</h4><span class="rv-sk__status'+(limited?' rv-sk__status--limited':'')+'">'+h(lbl)+'</span></div>'+
            '<p class="rv-sk__address">'+h(address)+'</p>'+
            (item.city?'<p class="rv-sk__city">'+h(item.city)+'</p>':'')+
            (url?'<a class="rv-sk__map" target="_blank" rel="noopener noreferrer" href="'+h(url)+'">'+h(t('maps'))+' <span aria-hidden="true">↗</span></a>':'')+'</article>';
        }
        markup+='</div>';
      }
      if(found.length>6)markup+='<button type="button" class="rv-sk__more" data-rv-sk-more>'+h(limit<found.length?t('more'):t('less'))+' <span aria-hidden="true">'+(limit<found.length?'↓':'↑')+'</span></button>';
      markup+='<p class="rv-sk__footnote">'+h(value.settings?.[lang==='ar'?'disclaimerAr':'disclaimerEn']||t('update'))+'</p></div>';
      const focused=document.activeElement?.hasAttribute('data-rv-sk-search');
      const oldStart=focused?document.activeElement.selectionStart:null;
      el.innerHTML=markup;
      bindStoreSizePicker();
      const searchEl=el.querySelector('[data-rv-sk-search]');
      if(searchEl){
        searchEl.addEventListener('input',event=>{search=event.target.value;limit=6;listStores()});
        if(focused){searchEl.focus({preventScroll:true});if(oldStart!=null)try{searchEl.setSelectionRange(oldStart,oldStart)}catch{}}
      }
      el.querySelector('[data-rv-sk-more]')?.addEventListener('click',()=>{limit=limit<found.length?found.length:6;listStores()});
    }
    // Prices and fee calculations are never recomputed in Shopify.
    // Every displayed quote is copied from a Sidekick-calculated tenor quote.
    const hasMoney=(n)=>n!==null&&n!==undefined&&n!==''&&Number.isFinite(Number(n));
    const money=(major,minor)=>{
      if(!hasMoney(major)&&!hasMoney(minor))return null;
      if(hasMoney(major)&&hasMoney(minor)&&Math.abs(Math.round(Number(major)*100)-Number(minor))>1)return null;
      const value=hasMoney(minor)?Number(minor)/100:Number(major);
      if(!Number.isFinite(value)||value<0)return null;
      return new Intl.NumberFormat(lang==='ar'?'ar-EG':'en-EG',{
        minimumFractionDigits:2,maximumFractionDigits:2
      }).format(value)+(lang==='ar'?' ج.م':' EGP');
    };
    const t2=(en,ar)=>lang==='ar'?ar:en;
    const selectedQuotes=(p)=>{
      const all=Array.isArray(p.tenorQuotes)?p.tenorQuotes:[];
      const defaultQuote=p.selectedTenorQuote;
      const valid=q=>q&&Number.isInteger(Number(q.tenorMonths))&&Number(q.tenorMonths)>0
        &&money(q.installmentAmountEgp,q.installmentAmountPiastres)!==null;
      const byTenor=new Map();
      for(const quote of all)if(valid(quote))byTenor.set(Number(quote.tenorMonths),quote);
      if(valid(defaultQuote))byTenor.set(Number(defaultQuote.tenorMonths),defaultQuote);
      const options=Array.from(byTenor.values()).sort((a,b)=>a.tenorMonths-b.tenorMonths);
      const desired=Number(termSelection.get(String(p.planId||p.providerId))||
        p.selectedTenorMonths||p.defaultTenorMonths||defaultQuote?.tenorMonths);
      const quote=options.find(x=>Number(x.tenorMonths)===desired)||defaultQuote||options[0];
      return {options,quote:valid(quote)?quote:null};
    };
    function drawInstallments(){
      if(!cache)return;
      const data=cache;
      const plans=Array.isArray(data.plans)?data.plans.filter(p=>p?.eligibility?.isEligible!==false):[];
      if(data.featureEnabled===false||plans.length===0){
        el.innerHTML='<div class="rv-sk__empty rv-sk__install-empty"><strong>'+h(t2('NO INSTALLMENT PLANS AVAILABLE','لا توجد خطط تقسيط متاحة'))+'</strong><p>'+h(t('noPlans'))+'</p></div>';
        return;
      }
      const priceContext=money(data.monetaryContext?.effectivePriceEgp,
        data.monetaryContext?.effectivePricePiastres);
      let markup='<div class="rv-sk__section rv-sk__install-section">'+
        '<div class="rv-sk__heading rv-sk__install-heading">'+
        '<span class="rv-sk__eyebrow">RAVIN / PAY YOUR WAY</span>'+
        '<strong>'+h(t2('YOUR PAYMENT OPTIONS','اختار طريقة التقسيط'))+'</strong>'+
        '<small>'+h(t('basedOn'))+
        (priceContext?' <b>'+h(priceContext)+'</b>':'')+'</small></div>'+
        '<div class="rv-sk__install-cards">';
      let rendered=0;
      for(const p of plans){
        const result=selectedQuotes(p);
        const quote=result.quote;
        if(!quote)continue;
        const monthly=money(quote.installmentAmountEgp,quote.installmentAmountPiastres);
        if(!monthly)continue;
        const today=money(quote.payableTodayEgp,quote.payableTodayPiastres);
        const total=money(quote.totalPayableAmountEgp,quote.totalPayableAmountPiastres);
        const fee=money(quote.totalAdminFeeAmountEgp,quote.totalAdminFeeAmountPiastres);
        const interest=money(quote.totalInterestAmountEgp,quote.totalInterestAmountPiastres);
        const down=money(quote.downPaymentAmountEgp,quote.downPaymentAmountPiastres);
        const name=p[lang==='ar'?'providerNameAr':'providerNameEn']||p.providerName||p.canonicalProviderKey||'';
        const logo=logoUrl(p.logoUrl);
        const key=String(p.planId||p.providerId||rendered);
        const note=quote[lang==='ar'?'summaryTextAr':'summaryTextEn']||
          p.content?.[lang==='ar'?'paymentNoteAr':'paymentNoteEn']||'';
        const feeNote=quote[lang==='ar'?'feeNoteAr':'feeNoteEn']||
          p.content?.[lang==='ar'?'customFeeNoteAr':'customFeeNoteEn']||'';
        const badge=p.promotions?.hasActivePromoBadge===true?
          p.promotions?.[lang==='ar'?'promoBadgeTextAr':'promoBadgeTextEn']||t('promotions'):'';
        const details=p.promotions?.[lang==='ar'?'offerDetailsAr':'offerDetailsEn']||'';
        const disclaimer=p.content?.[lang==='ar'?'disclaimerAr':'disclaimerEn']||'';
        const terms=p.eligibility?.[lang==='ar'?'eligibilityConditionsAr':'eligibilityConditionsEn'];
        rendered++;
        markup+='<article class="rv-sk__install-card" data-rv-sk-plan="'+h(key)+'">'+
          '<div class="rv-sk__install-provider">'+
          (logo?'<img class="rv-sk__install-logo" src="'+h(logo)+'" alt="'+h(name)+'" loading="lazy">':'')+
          '<div class="rv-sk__install-provider-name"><strong>'+h(name)+'</strong>'+
          '<span>'+h(t2('PAYMENT PARTNER','شريك التقسيط'))+'</span></div></div>'+
          (badge?'<div class="rv-sk__install-promo"><span>'+h(badge)+'</span></div>':'')+
          '<div class="rv-sk__install-hero"><div><span class="rv-sk__install-micro">'+h(t2('PAY','القسط'))+'</span>'+
          '<strong class="rv-sk__install-amount">'+h(monthly)+'</strong>'+
          '<span class="rv-sk__install-period">'+h(quote.paymentFrequency==='MONTHLY'?
            t('perMonth'):t2('per installment','لكل دفعة'))+'</span></div>'+
          '<span class="rv-sk__install-months">'+h(quote.tenorMonths)+' '+
            h(t('months'))+'</span></div>';
        if(result.options.length>1){
          markup+='<div class="rv-sk__install-tenors"><span>'+h(t2('CHOOSE YOUR PLAN','اختار مدة التقسيط'))+'</span>'+
            '<div class="rv-sk__install-tenor-buttons" role="group" aria-label="'+h(t('months'))+'">';
          for(const choice of result.options){
            const active=Number(choice.tenorMonths)===Number(quote.tenorMonths);
            markup+='<button type="button" data-rv-sk-tenor="'+h(choice.tenorMonths)+
              '" data-rv-sk-plan-key="'+h(key)+'" aria-pressed="'+active+
              '" class="'+(active?'is-active':'')+'">'+h(choice.tenorMonths)+' '+h(t('months'))+'</button>';
          }
          markup+='</div></div>';
        }
        if(note)markup+='<p class="rv-sk__install-note">'+h(note)+'</p>';
        markup+='<div class="rv-sk__install-summary">'+
          (today!==null?line(t('payToday'),today):'')+
          (total!==null?line(t('total'),total):'')+'</div>';
        const feeRows=(fee!==null?line(t2('Administration fees','المصاريف الإدارية'),fee):'')+
          (interest!==null?line(t2('Interest','الفوائد'),interest):'')+
          (down!==null?line(t2('Down payment','المقدم'),down):'');
        const termItems=(Array.isArray(terms)?terms:[]).map(v=>'<p>'+h(v)+'</p>').join('');
        if(feeNote||feeRows||details||termItems||disclaimer){
          markup+='<details class="rv-sk__install-details"><summary>'+h(t('terms'))+'</summary>'+
          (feeRows?'<div class="rv-sk__install-fees">'+feeRows+'</div>':'')+
          (feeNote?'<p>'+h(feeNote)+'</p>':'')+
          (details?'<p class="rv-sk__install-offer">'+h(details)+'</p>':'')+
          termItems+(disclaimer?'<p>'+h(disclaimer)+'</p>':'')+'</details>';
        }
        markup+='</article>';
      }
      markup+='</div><p class="rv-sk__footnote rv-sk__install-legal">'+
        h(t('disclaimer'))+'</p></div>';
      if(!rendered){
        el.innerHTML='<div class="rv-sk__error" role="alert">'+
          h(t2('Installment quotes are currently unavailable. Please try again.',
          'تفاصيل التقسيط غير متاحة حالياً. حاول مرة تانية.'))+'</div>';
        return;
      }
      // Keep open detail cards in place when changing a payment period.
      const expanded=Array.from(el.querySelectorAll('.rv-sk__install-card'))
        .filter(c=>c.querySelector('.rv-sk__install-details[open]'))
        .map(c=>c.dataset.rvSkPlan);
      const scrollPanel=el.closest('.rpa-pdp-utility-scroll');
      const scrollTop=scrollPanel?.scrollTop;
      el.innerHTML=markup;
      el.querySelectorAll('.rv-sk__install-card').forEach(card=>{
        if(expanded.includes(card.dataset.rvSkPlan)){
          const detail=card.querySelector('.rv-sk__install-details');
          if(detail)detail.open=true;
        }
      });
      if(scrollPanel&&scrollTop!==undefined)scrollPanel.scrollTop=scrollTop;
      el.querySelectorAll('[data-rv-sk-tenor]').forEach(button=>{
        button.addEventListener('click',()=>{
          const plan=button.dataset.rvSkPlanKey;
          termSelection.set(plan,Number(button.dataset.rvSkTenor));
          drawInstallments();
        });
      });
    }
    async function refresh(force=false){
      const variant=selectedVariant();
      if(!variant||!variant.id){el.innerHTML='<p class="rv-sk__empty">'+h(t('failed'))+'</p>';return}
      const minor=service==='installments'?currentPrice(variant):null;
      const key=String(variant.id)+'|'+(minor||'');
      if(!force && key===current && (cache||inFlightKey===key))return;
      if(controller)controller.abort();
      controller=new AbortController();
      const n=++seq,req='rv-'+service+'-'+n;
      current=key;cache=null;inFlightKey=null;search='';limit=6;
      if(service==='installments'&&(storefrontCurrency!=='EGP'||minor===null||minor<=0)){
        el.innerHTML='<p class="rv-sk__empty">'+h(t('failed'))+'</p>';return;
      }
      if(!apiHost||!/^https:\/\//.test(apiHost)){error();return}
      loading();
      inFlightKey=key;
      let url,options={headers:{Accept:'application/json'},credentials:'omit',signal:controller.signal};
      if(service==='stores'){
        const params=new URLSearchParams({variantId:String(variant.id),clientRequestId:req});
        if(productId)params.set('productId',productId);
        url=apiHost+'/api/public/v1/store-availability?'+params;
      }else{
        url=apiHost+'/api/public/v1/installments/plans';
        options={...options,method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({variantId:String(variant.id),productId,effectivePricePiastres:minor,currency:'EGP',clientRequestId:req})};
      }
      // A hung Cloud Run request must not leave shoppers on a permanent loading state.
      let timedOut=false;
      const requestController=controller;
      const timeout=setTimeout(()=>{timedOut=true;requestController.abort()},14000);
      try{
        const response=await fetch(url,options);
        const data=await response.json().catch(()=>{throw new Error('INVALID_JSON')});
        if(!response.ok)throw new Error('HTTP_'+response.status);
        if(data?.ok!==true)throw new Error('API_NOT_OK');
        if(n!==seq)return;
        if(data.clientRequestId&&data.clientRequestId!==req)throw new Error('REQUEST_MISMATCH');
        if(service==='installments'){
          const ctx=data.monetaryContext;
          const reported=ctx&&hasMoney(ctx.effectivePricePiastres)?
            Number(ctx.effectivePricePiastres):
            ctx&&hasMoney(ctx.effectivePriceEgp)?Math.round(Number(ctx.effectivePriceEgp)*100):null;
          if(!ctx || ctx.currency!=='EGP' || !Number.isSafeInteger(reported) ||
            Math.abs(reported-minor)>1)throw new Error('PRICE_MISMATCH');
        }
        cache=data;
        delete el.dataset.rvSkError;
        if(service==='stores')listStores();else drawInstallments();
      }catch(err){
        if(n!==seq||err?.name==='AbortError'&&!timedOut)return;
        // Diagnostic codes only: no credentials, inventory counts or installment data.
        const code=timedOut?'TIMEOUT':err?.name==='TypeError'?'NETWORK_OR_CORS':
          /^HTTP_[0-9]{3}$/.test(err?.message||'')?err.message:
          ['INVALID_JSON','API_NOT_OK','REQUEST_MISMATCH','PRICE_MISMATCH'].includes(err?.message)?err.message:'API_UNAVAILABLE';
        error(code);
      }finally{clearTimeout(timeout);if(n===seq)inFlightKey=null}
    }
    // A campaign price can change without changing the variant.
    pdp.addEventListener('ravin:priceChanged',()=>{
      if(service!=='installments')return;
      if(details&&!details.open){if(controller)controller.abort();seq++;cache=null;current=null;inFlightKey=null;return}
      refresh();
    });
    pdp.addEventListener('ravin:variantChanged',()=>{
      // Refresh only when visible; defer network calls while the accordion is closed.
      if(details && !details.open){
        if(controller)controller.abort();
        seq++;
        cache=null;current=null;inFlightKey=null;
        return;
      }
      refresh();
    });
    if(details){
      details.addEventListener('toggle',()=>{
        if(details.open&&!cache)refresh();
      });
      if(details.open)refresh();
      else el.innerHTML='';
    }else refresh();
  }
  function boot(scope){scope.querySelectorAll?.('[data-rv-sidekick-native]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();
